export default __webpack_public_path__ + "b3371c38be1b1f69c77703f13fceeb8d.jpg";